export const listMutations = <const>{
	ZAKAZNIK_ID_FILTER_SELECT_MAPPER: 'ZAKAZNIK_ID_FILTER_SELECT_MAPPER',
};
